export default "__VITE_ASSET__D7iCQfxu__"